// @ts-strict-ignore
import {FUNNELS_TIME_TO_CONVERSION} from 'common/query-builder/query-block/properties-menu/constants';
import {MetricEntry, RowLabelType} from 'common/query-builder/query-entry-section/types';
import {ChartType, FUNNELS_MATH_TYPES} from 'common/types/reports/bookmark';
import {generateStepRanges} from 'common/widgets/step-range-selector/util';

export function getStepSelectionOptions({entry, chartType}: {entry: MetricEntry; chartType: ChartType}) {
  return generateStepRanges({
    entry: {
      isEntireRange: entry.measurement.stepIndex === null,
      range:
        entry.measurement.stepIndex === null
          ? {}
          : {
              from: entry.measurement.stepIndex || 0,
              to: (entry.measurement.stepIndex || 0) + 1,
            },
    },
    steps: entry.behavior.behaviors.length,
    rowLabelType: RowLabelType.Numeric,
    disableAllSteps: false,
    disableEnteringFunnel:
      [
        FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE,
        FUNNELS_MATH_TYPES.CONVERSION_RATE_TOTAL,
        FUNNELS_MATH_TYPES.CONVERSION_RATE_SESSION,
      ].includes(entry.measurement.aggregationOperator as FUNNELS_MATH_TYPES) ||
      entry.measurement.property?.value === FUNNELS_TIME_TO_CONVERSION.value,
    onlyAllSteps: chartType === ChartType.FunnelSteps,
    isReportConsistency: true,
  });
}

export function getStepSelectionLabel({entry, chartType}: {entry: MetricEntry; chartType: ChartType}) {
  // todo: i18n
  return getStepSelectionOptions({entry, chartType}).find((option) => option.isSelected)?.label as string;
}
